import { Component, OnInit } from '@angular/core';
import { PaymentService } from '../_services/payment.service';
import { FloatingLicenseSnapshot } from '../_models/FloatingLicenseSnapshot';
import { ToastService } from 'on-common/_services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'on-floating-licenses-history-page',
    templateUrl: './floating-licenses-history-page.component.html',
    styleUrls: ['./floating-licenses-history-page.component.scss'],
})
export class FloatingLicensesHistoryPageComponent implements OnInit {
    selectedDate: Date | string;
    snapshots: FloatingLicenseSnapshot[] = [];
    isLoading = false;
    hasLoadedOnce = false;

    constructor(
        private paymentService: PaymentService,
        private toastService: ToastService,
        private translateService: TranslateService,
    ) {}

    ngOnInit(): void {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        yesterday.setHours(0, 0, 0, 0);
        this.selectedDate = yesterday;
        this.loadSnapshots();
    }

    onDateChange(): void {
        if (this.selectedDate) {
            this.loadSnapshots();
        }
    }

    loadSnapshots(): void {
        if (!this.selectedDate) {
            return;
        }
        const dateValue = new Date(this.selectedDate);
        this.isLoading = true;
        this.paymentService
            .GetFloatingLicensesByDate(dateValue)
            .subscribe({
                next: (response) => {
                    if (response.IsSuccess) {
                        this.snapshots = (response.Result || []).map(
                            (s) => new FloatingLicenseSnapshot(s),
                        );
                    } else {
                        this.snapshots = [];
                        this.toastService.error(
                            this.translateService.instant(
                                'payment.floatingLicensesHistory.loadError',
                            ),
                        );
                    }
                    this.hasLoadedOnce = true;
                    this.isLoading = false;
                },
                error: () => {
                    this.snapshots = [];
                    this.hasLoadedOnce = true;
                    this.isLoading = false;
                    this.toastService.error(
                        this.translateService.instant(
                            'payment.floatingLicensesHistory.loadError',
                        ),
                    );
                },
            });
    }
}
